export default __webpack_public_path__ + "static/media/start.717b0931.png";